import { combineReducers } from "redux";

import loanOffers from "./reducers/loanOffers";
import loanOffer from "./reducers/loanOffer";
import ui from "./reducers/ui";

const loanOfferReducers = combineReducers({
  all: loanOffers,
  loanOffer: loanOffer,
  ui: ui,
});

export default loanOfferReducers;



// WEBPACK FOOTER //
// ./src/features/loans/reducers.js